export const getLocationHash = (): string => {
    return document.location.hash;
};
